/**
 * TypeBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type TypeBox = {
	majorBrand: string;
	minorVersion: number;
	compatibleBrands: string[];
};
